import { toggleElementInCollection } from '../../../helpers/toggleElementInCollection';
import { CheckboxGroupChangeModelLazy } from '../../../models/CheckboxGroupChangeModel';
import { CheckboxGroupItemChangeModel } from '../../../models/CheckboxGroupItemChangeModel';
export function prepareMultiplyCheckboxGroupItemChangeModel(nestedCheckboxesService, values, checkboxGroupItem) {
  var calcAllValues = function calcAllValues() {
    return toggleElementInCollection(checkboxGroupItem.value, values);
  };

  var calcGroupValues = function calcGroupValues() {
    return calcAllValues().filter(function (value) {
      return nestedCheckboxesService.group.items.some(function (el) {
        return el.value === value;
      });
    });
  };

  var calcAllItems = function calcAllItems() {
    var allValuesCollection = new Set(calcAllValues());
    return nestedCheckboxesService.group.items.filter(function (item) {
      return allValuesCollection.has(item.value);
    });
  };

  var checkboxGroupChangeModel = new CheckboxGroupChangeModelLazy(nestedCheckboxesService.group, calcAllValues, calcGroupValues, calcAllItems);
  return new CheckboxGroupItemChangeModel(checkboxGroupChangeModel, checkboxGroupItem);
}